module.exports = __webpack_public_path__ + "static/media/menu_corner_upper_left.05d11422.png";